import '@/public-path.js'
import '@/utils/parentWin.js'
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
import configAxios from '@/config/axios'
import '@/utils/receiveMessage'
import postMessage from '@/utils/postMessage'
import analysis from '@/utils/analysis'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import '@/style/element-theme/index.css'

import '@/style/common.styl'
import '@/style/font/icon-bass.css'
// import '@/style/font-one/icon-one.css'

// import oneIcon from '@/pages/client/components/oneIcon'
import '../../assets/iconfont/iconfont.css'

Vue.use(ElementUI)
Vue.prototype.$analysis = analysis
Vue.prototype.$postMessage = postMessage

configAxios({
  needLogin () {
    window.parent.postMessage({
      action: 'needLogin'
    }, process.env.VUE_APP_IFRAME_DOMAIN)
  }
})
let rootApp = null
function initApp (props = {}) {
  const { container } = props
  rootApp = new Vue({
    router,
    store,
    render: h => h(App, {
      attrs: {}
    })
  }).$mount(container ? container.querySelector('#app') : '#app')

  window.rootApp = rootApp
}

if (!window.__POWERED_BY_QIANKUN__) {
  initApp()
}

export async function bootstrap() {
  console.log('work-plat app bootstraped')
}
export async function mount(props) {
  console.log('work-plat props from main framework', props)
  initApp(props)
}
export async function unmount() {
  rootApp.$destroy()
  rootApp.$el.innerHTML = ''
  rootApp = null
}
